export default __webpack_public_path__ + "static/media/PepperPlan-logo.273daf2b.png";